<template>
  <div class="corporation_detail">
    <div
      v-for="headerTitle in headerTitles"
      :key="headerTitle.value"
      class="title_header"
      :style="{backgroundColor: headerTitle.color}"
    >
      <div
        class="title_header_value vertical_align_div"
        @click="pageLink(headerTitle.path)"
      >
        <span class="header_router">
          {{ headerTitle.value }}
        </span>
      </div>
    </div>
    <div class="corporation_contents">
      <div class="corporation_contents_background">
        <div class="corporation_edit_area_title">
          {{ contractEditInfoTitle }}
        </div>
        <contractEditInfo></contractEditInfo>
        <div class="corporation_edit_area_title">{{ tenantEditInfoTitle }}</div>
        <tenantEditInfo></tenantEditInfo>
        <div class="corporation_edit_area_title">
          {{ tenantOptionEditInfoTitle }}
        </div>
        <tenantOptionEditInfo></tenantOptionEditInfo>
      </div>
      <div class="corporation_bottom">
        <div class="corporation_bottom_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="okButton"
            class="finish_button"
            @click="editCorporation"
          />
        </div>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="toDetail">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import contractEditInfo from '../CorporationView/corporationComponents/contractUpdateInfo.vue'
import tenantEditInfo from '../CorporationView/corporationComponents/tenantUpdateInfo.vue'
import tenantOptionEditInfo from '../CorporationView/corporationComponents/tenantOptionUpdateInfo.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      contractEditInfoTitle: '編集内容確認',
      tenantEditInfoTitle: 'テナント情報',
      tenantOptionEditInfoTitle: 'テナントオプション',
      cancelButton: 'キャンセル',
      okButton: '変更',
      headerTitle: '編集',
      completeWord: '変更しました。',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      showMailSendModal: false,
      contentsHeight: '',
      contentsBackgroundHeight: ''
    }
  },
  computed: {
    headerTitles() {
      return this.$store.state.masters.editHeaderTitle
    },
    corporation() {
      return this.$store.state.corporations.corporation
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    tenantEditInfo,
    contractEditInfo,
    tenantOptionEditInfo,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      var contaractHeight =
        document.getElementById('contract_info').clientHeight
      var tenantHeight = document.getElementById('tenant_info').clientHeight
      var tenantOptionHeight =
        document.getElementById('tenant_option_info').clientHeight
      var maxHeight = contaractHeight
      if (maxHeight < tenantHeight) {
        maxHeight = tenantHeight
      }
      if (maxHeight < tenantOptionHeight) {
        maxHeight = tenantOptionHeight
      }
      var height = maxHeight
      var contentsPaddingHeight = 52
      var buttonHeight = 40
      this.contentsHeight = height + contentsPaddingHeight + buttonHeight + 'px'
      this.contentsBackgroundHeight = height + 'px'
    },
    pageLink(path) {
      this.$router.push(path)
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/master/corporations')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async cancel(e) {
      this.showloadingModal = true
      this.$router.push('/master/corporations/edit')
    },
    async editCorporation(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('corporations/updateCorporation')
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_130001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0047')
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch(
          'corporations/setDetailCorporation',
          this.corporation.companyId
        )
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_130001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0046')
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }

      this.showModal = false
      this.showCompleteModal = true
      this.showloadingModal = false
    },
    toDetail() {
      this.showCompleteModal = false
      this.$router.push('/master/corporations/detail')
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationEditConfirm.vue